import React from 'react';
import clsx from 'clsx';
import { ButtonProps } from './types';
import { styles } from './styles';
import { Spinner } from '../Spinner';

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  icon,
  iconPosition = 'left',
  disabled,
  className,
  children,
  ...props
}) => {
  return (
    <button
      className={clsx(
        styles.base,
        styles.variants[variant],
        styles.sizes[size],
        (disabled || isLoading) && styles.disabled,
        className,
      )}
      disabled={disabled || isLoading}
      {...props}>
      {isLoading && <Spinner size="sm" />}
      {!isLoading && iconPosition === 'left' && icon}
      {children}
      {!isLoading && iconPosition === 'right' && icon}
    </button>
  );
};

export type { ButtonProps, ButtonVariant, ButtonSize } from './types';
export default Button;
